import { Injectable } from '@angular/core';
import { LanguageService } from './language.service';

@Injectable({
  providedIn: 'root'
})
export class LogoService {
  private static readonly SUPPORTED_LANGUAGES = ['ar', 'en', 'de', 'fa', 'fr', 'hi', 'id', 'pt', 'es', 'ru', 'th', 'tr', 'vi', 'zh'];
  private usedLanguage = 'de';

  constructor(private languageService: LanguageService) {
    this.usedLanguage = this.languageService.getLanguage();
  }

  get logoSource(): string {
    if (LogoService.SUPPORTED_LANGUAGES.indexOf(this.usedLanguage) > -1) {
      return 'assets/logos/aa_' + this.usedLanguage + '.svg';
    }
    return 'assets/logos/aa_en.svg';
  }

}
